export default __webpack_public_path__ + "static/media/Nunito-SemiBold.689a49a3.ttf";